import {
  ClientSearchFormValues,
  ClientSearchFormViolation,
} from 'types/clientSearchFormTypes';

export const CLIENT_SEARCH__MIN_TEXT_LENGTH = 3;

export const createClientSearchFormValues = (): ClientSearchFormValues => ({
  text: '',
  client: null,
});

export const validateClientSearchFormValues = (
  values: ClientSearchFormValues
): ClientSearchFormViolation[] => {
  const violations: ClientSearchFormViolation[] = [];

  if (!values.text) {
    violations.push({
      name: 'TextIsEmpty',
    });
  }

  if (values.text.length < CLIENT_SEARCH__MIN_TEXT_LENGTH) {
    violations.push({
      name: 'TextTooShort',
    });
  }

  if (values.client === null) {
    violations.push({
      name: 'ClientNotSelected',
    });
  }

  return violations;
};
